<template>
<div class="web-views">
  <div class="btn-box" style="display:none">
    <p class="box-title">税法税便问</p>
    <button class="btn-back" @click="goBack()">返回上一页</button>
    <button class="btn-back" @click="goBackHome()">返回首页</button>
  </div>
  <div class="collectionTitle" style="display:none">
      问题详情
  </div>
  <div class="dataListBox">
      <!--返回收藏列表-->
      <div class="goScList" @click="goDownHandle">
        <img :src="goDown" alt="">
        <div class="goScListText">返回收藏列表</div>
      </div>
      <!--问题-->
      <div class="questionBox">
          <div v-if="questionType==0">
              <div>
                <span >问：  </span>
                <span v-html='question'></span>
            </div>
          </div>
          <div v-if="questionType==1">
              <text space="ensp">问：  </text>
                <img :src="question" alt="">
          </div>
      </div>
      <!--线-->
      <div class="xianCenter"></div>
      <!--回答-->
      <div class="answerBox">
          <div v-if="answerType==0">
              <span>答：  </span>
                <span v-html='answer'></span>
          </div>
          <div v-if="answerType==1">
              <span>答：  </span>
                <img :src="answer" @click.stop="previewImage(answer)" alt="">
          </div>
      </div>
      <!--来源-->
      <div class="timeBox">
          <span>来源：  </span>
            {{ source }}
      </div>
      <!--时间-->
      <div class="timeBox1">
          <span>时间：  </span>
            {{ times }}
      </div>
  </div>
</div>
</template>

<script>

    import { API_DATA } from "@/api/index";

    import goDown from '@/assets/goDown.png'

    export default{
        name:'dayiDetails',
        data(){
            return{
                tid:'',
                tData:[],
                //问题
				question:'',
				//回答
				answer:'',
				//问题类型
				questionType:0,
				//回答类型
				answerType:0,
				//时间
				times:'',
				//来源
                source:'',
                //返回图片
                goDown,
            }
        },
        created(){
            let vuexID = this.$store.state.dayiDetailID.id
            let decodeId = decodeURIComponent(vuexID)
            this.tid = decodeId;
            
            this.getDayiDetail()
        },
        methods:{
            goBack() {
                window.history.go(-1)
            },
            goBackHome(){
                this.$router.push('/')
            },
            goDownHandle(){
              window.history.go(-1)
            },
            //获取详情数据
            getDayiDetail(){
                let url = 'dataCenter/detail2';
                let data = {
                    articleId:this.tid,
                }
                API_DATA.doPostDataSBW(data,url).then(res => {
                    if(res.status == 0){
                        this.tData = res.data.data[0];
						this.question = this.tData.title;
						this.answer = this.tData.content_formatted;
						
						if(this.answer.indexOf('答：')!=-1){
							let thatAnswer = this.answer
							let thatIndex = this.answer.indexOf('答：') + 2
							thatAnswer =  thatAnswer.slice(thatIndex)
							this.answer = thatAnswer;
						}
						this.times = this.tData.publish_time;
						this.source = this.tData.source
                    }else{
                        console.log('服务请求失败',res)
                    }
                    console.log(this.tData)
                })
            }
        }
    }

</script>
<style scoped>
.content{
  height: calc(100vh - 50px);
}
.btn-box{
  width: 100%;
  line-height: 50px;
  height: 50px;
  flex-direction: row-reverse;
  justify-content: space-between;
}
.box-title{
    width: 220px;
    float: left;
  padding-left: 20px;
}
.btn-back{
  /* position: fixed; */
  float: right;
  width: 100px;
  height: 30px;
  line-height: 30px;
  margin: 10px 15px;
  border-radius: 5px;
  border: 1px solid #eeeeee;
}

.collectionTitle{
    width:100%;
    height:50px;
    background: #11607b;
    line-height: 48px;
    text-align: center;
    color:#ffffff;
}


.dataListBox{
    /*width: calc(100% - 40px);*/
    width: calc(100%);
    background: #ffffff;
    overflow: hidden;
    margin-top:10px;
    box-sizing: border-box;
    padding:30px;
}

/**返回收藏列表 */
.goScList{
  width:150px;
  height:20px;
  line-height: 20px;
  margin-bottom: 12px;
  cursor: pointer;
}
.goScList img{
  width: 16px;
  height:16px;
  float:left;
  margin-right:6px;
}
.goScListText{
  width: 100px;
  height:20px;
  float:left;
  color:#2770e6;
  font-size:16px;
}

/**问题样式*/
	.questionBox{
		color:333333;
		line-height: 30px;
		font-size: 16px;
		font-weight: 700;
		font-family: SourceHanSansCN-Bold;
		word-break:break-all;
	}
	/**中间隔断线*/
	.xianCenter{
		margin-top:20px ;
		margin-bottom:20px ;
		background: #ededed;
		height:1px;
	}
	/**回答*/
	.answerBox{
		width: 100%;
		height: 100%;
		line-height: 30px;
		font-size: 16px;
		color:#333333;
		font-family: SourceHanSansCN-Regular;
		word-break:break-all;
	}
	.answerBox img{
		width: 100%;
	}
	/**时间*/
	.timeBox{
		margin-top:30px;
		color:#888888;
		font-size: 16px;
		font-family: SourceHanSansCN-Regular;
	}
    .timeBox1{
        margin-top:15px;
		color:#888888;
		font-size: 16px;
		font-family: SourceHanSansCN-Regular;
    }
</style>